/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ListSettlementsByTenantOptions,
  ListSettlementsByTenantStatus200,
  ListSettlementsByTenantStatus400,
  ListSettlementsByTenantStatus500,
} from '../types/ListSettlementsByTenant'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listSettlementsByTenant } from '../clients/listSettlementsByTenant'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listSettlementsByTenantQueryKey = ({
  query,
}: Omit<ListSettlementsByTenantOptions, 'headers'> = {}) =>
  [{ url: '/v1/tenants/settlements' }, ...(query ? [query] : [])] as const

type ListSettlementsByTenantQueryKey = ReturnType<typeof listSettlementsByTenantQueryKey>

export function listSettlementsByTenantQueryOptions(
  { query }: ListSettlementsByTenantOptions = {},
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = listSettlementsByTenantQueryKey({ query })
  return queryOptions<
    ListSettlementsByTenantStatus200,
    ResponseErrorConfig<ListSettlementsByTenantStatus400 | ListSettlementsByTenantStatus500>,
    ListSettlementsByTenantStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return listSettlementsByTenant({
        ...config,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary List settlements by optional filters.
 * {@link /v1/tenants/settlements}
 */
export function useListSettlementsByTenant<
  TData = ListSettlementsByTenantStatus200,
  TQueryData = ListSettlementsByTenantStatus200,
  TQueryKey extends QueryKey = ListSettlementsByTenantQueryKey,
>(
  {
    query,
  }: {
    query?:
      | ListSettlementsByTenantOptions['query']
      | (() => ListSettlementsByTenantOptions['query'])
  } = {},
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListSettlementsByTenantStatus200,
        ResponseErrorConfig<ListSettlementsByTenantStatus400 | ListSettlementsByTenantStatus500>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? listSettlementsByTenantQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...listSettlementsByTenantQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<ListSettlementsByTenantStatus400 | ListSettlementsByTenantStatus500>
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
